export default "__VITE_ASSET__BP7cAe_C__"